import clsx from 'clsx';
import { useState } from 'react';
import AppHeader from '../../components/app-header';
import SideBar from '../../components/side-bar';
import SideExplorer from '../../components/side-explorer';
import MainAdminPageNavigator from '../../navigator/main-admin-page';
import { SideBarMenuOptions } from '../../types/side-bar-menu-options';
import './index.css';
import AppBreadcrumb from '../../components/app-breadcrumb';
import { useVariablesContext } from '../../stores/variables-context';
import { useGroupsContext } from '../../stores/groups-context';
import { useRulesContext } from '../../stores/rules-context';
import { useJobsContext } from '../../stores/jobs-context';
import { useDataCertificationsContext } from '../../stores/data-certifications-context';
import { Outlet } from 'react-router-dom';

function MainAdminPage(): JSX.Element {
  const [tab, setTab] = useState<SideBarMenuOptions>(undefined);
  const [filter, setFilter] = useState('');
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const jobsContext = useJobsContext();
  const rulesContext = useRulesContext();
  const variablesContext = useVariablesContext();
  const dataCertificationsContext = useDataCertificationsContext();
  const groupsContext = useGroupsContext();

  function resetFilter(value: string) {
    setFilter(value);
    switch (tab) {
      case 'Jobs':
        if (jobsContext.filterData) jobsContext.filterData(value);
        return;
      case 'Rules':
        if (rulesContext.filterData) rulesContext.filterData(value);
        return;
      case 'Groups':
        if (groupsContext.filterData) groupsContext.filterData(value);
        return;
      case 'Variables':
        if (variablesContext.filterData) variablesContext.filterData(value);
        return;
      case 'Data Certifications':
        if (dataCertificationsContext.filterData) dataCertificationsContext.filterData(value);
        return;
      default:
        return;
    }
  }

  return (
    <div className='main_admin_root'>
      <AppHeader />
      <AppBreadcrumb />
      <div className='main_admin_content'>
        <div className='main_admin_side-bar-panel'>
          <SideBar selected={tab} setSelected={setTab} resetFilter={resetFilter} setCollapsed={setCollapsed} />
        </div>
        <div className='main_admin_resize-container'>
          {tab !== 'Data Certifications' && (
            <div
              className={clsx('main_admin_left-side-navigation-panel', {
                '--collapsed': collapsed,
              })}
            >
              <div className={clsx('main_admin_left-side-navigation-container')}>
                <SideExplorer tab={tab} filter={filter} onFilter={setFilter} />
              </div>
            </div>
          )}
          <div className='main_admin_center-page-content-panel'>
            <MainAdminPageNavigator />
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default MainAdminPage;
